import { CONFIG } from '../../core/config';
import { DeferralStatusType } from '../../shared/mitigation-plan/deferral-status-type';
import { BusinessEntity } from '../business-entity';

export class DeferralTask extends BusinessEntity {
  public deferralId: string;
  public inspectionPlanTaskId: string;
  public taskReference: string;
  public inspectionPriority: string;
  public taskExtent: string;
  public taskFrequency: number;
  public taskInterval: string;
  public overrideFrequency: boolean;
  public lastInspectionDate: string;
  public lastInspectionDateOverriden: boolean;
  public dueDate: Date;
  public revisedDueDate: Date;
  public dueDateOverridden: boolean;
  public deferralStatus: DeferralStatusType;
  public createdBy: string;
  public creationDate: string;
  public lastModifiedBy: string;
  public lastModifiedDate: string;
  public masterInspectionMethodId: string;
  public eventId : string;

  constructor() {
    super();
    this.friendlyTypeNameSingular = 'Deferral Task';
    this.apiRoute = CONFIG.apiRoutes.deferralTask;
  }

  public json() {
    return this;
  }

  public loadFromJson(data) {
    super.loadFromJson(data);
    this.deferralId = data.deferralId;
    this.inspectionPlanTaskId = data.inspectionPlanTaskId;
    this.taskReference = data.taskReference;
    this.inspectionPriority = data.inspectionPriority;
    this.taskExtent = data.taskExtent;
    this.taskFrequency = data.taskFrequency;
    this.taskInterval = data.taskInterval;
    this.overrideFrequency = data.overrideFrequency;
    this.lastInspectionDate = data.lastInspectionDate;
    this.lastInspectionDateOverriden = data.lastInspectionDateOverriden;
    this.dueDate = data.dueDate;
    this.revisedDueDate = data.revisedDueDate;
    this.dueDateOverridden = data.dueDateOverridden;
    this.deferralStatus = data.deferralStatus;
    this.createdBy = data.createdBy;
    this.creationDate = data.creationDate;
    this.lastModifiedBy = data.lastModifiedBy;
    this.lastModifiedDate = data.lastModifiedDate;
    this.masterInspectionMethodId = data.masterInspectionMethodId;
  }
}
